import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchContracts } from '../actions/contracts'

import ContractActiveList from '../components/ContractActiveList'
import ContractTerminatedList from '../components/ContractTerminatedList'
import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import "../styles/CustomersAdminView.css"

class ContractsView extends React.Component {
  componentDidMount() {
    this.props.fetchContracts()
  }

  render() {
    const { role, type, contracts, error } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!contracts) {
      return <LoadingProgress />;
    }

    return (
      <div className="customers-admin-view">
        <div className="customers-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-file-signature mr-3"></i>
                <span className="text-vw-dark mr-1">CONTRATOS</span>
                <span className="text-vw-light">ACTIVOS</span>
              </h1>
            </div>
            <div className="header-actions">
              {role === 'ADMIN' && type === 'MASTER' && (
                <Link to="/contracts/create" className="customers-admin-btn primary">
                  <i className="fas fa-plus"></i>
                  <span>Nuevo</span>
                </Link>
              )}
            </div>
          </div>
        </div>

        <ContractActiveList contracts={contracts} />

        <div className="customers-admin-header" style={{ marginTop: 20 }}>
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-file-signature mr-3"></i>
                <span className="text-vw-dark mr-1">CONTRATOS</span>
                <span className="text-vw-light">TERMINADOS</span>
              </h1>
            </div>
            <div className="header-actions"></div>
          </div>
        </div>

        <ContractTerminatedList contracts={contracts} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  contracts: state.contracts.contracts,
  error: state.contracts.error,
  role: state.auth.role,
  type: state.auth.type
})

const mapDispatchToProps = dispatch => ({
  fetchContracts: bindActionCreators(fetchContracts, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ContractsView)

